import React, { Component } from 'react';
import { View, Text, StyleSheet, TouchableWithoutFeedback, Image } from 'react-native';
import { observer, inject } from 'mobx-react/native';
import QImageSet from '../../../assets/QImageSet.js';
import RootStore from '../../../Store';
import uitls from '../businessComps/utils';
// import PPLogUtil from '../../../Utils/PPLogUtil';

interface Props {
    data: any,
    orderCellIndex: number
    onOrderItemPress(params: any, businessType: string, sysCode: any, orderNo: any, orderCellIndex: any): void;
}

@inject((stores: RootStore) => ({
    // 点击订单
    onOrderItemPress: stores.orderlist.onOrderItemPress
}))
@observer
export default class Cashback extends Component<Props> {

    _onPress = () => {
        // TODO 跳转详情页，切换check选中态，
        const { onOrderItemPress, data: { appAction, businessType, sysCode, orderNo } = {}, orderCellIndex } = this.props;
        // TODO 校验当前单是否处于删除状态中 checkOrderInDeleting(data.orderNo)
        if (onOrderItemPress) {
            onOrderItemPress(uitls.getDetailSchema(appAction), businessType, sysCode, orderNo, orderCellIndex);
        }
        //PPLogUtil.orderCardShowOrClickLog(OPER_CLICK, sysCode, orderNo, businessType, this.props.sourceFrom, (orderCellIndex + 1).toString());
    };

    render() {
        const { data } = this.props;

        return (
            <TouchableWithoutFeedback onPress={this._onPress}>
                <View style={styles.container}>
                    <Image source={{ uri: QImageSet.cashback_gift_icon }} style={styles.cashbackIcon} />
                    <Text style={styles.text} numberOfLines={1}>
                        {String(data?.scanCodeCashbackTip)?.split('[')[0]}
                        <Text style={styles.priceText}>
                            {String(data?.scanCodeCashbackTip)?.split('[')[1]?.split(']')[0]}
                        </Text>
                        {String(data?.scanCodeCashbackTip)?.split(']')[1]}
                    </Text>
                </View>
            </TouchableWithoutFeedback>
        )
    }

}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 16,
        //marginTop: -8,
        backgroundColor: '#F8F8F8',
        marginLeft: 16,
        marginRight: 15,
        paddingLeft: 8,
        paddingRight: 18,
        paddingVertical: 8,
        borderRadius: 6
    },
    cashbackIcon: {
        width: 12,
        height: 14.17,
        marginRight: 6
    },
    text: {
        fontFamily: 'PingFangSC-Regular',
        fontSize: 12,
        color: '#333333'
    },
    priceText: {
        color: '#FF6600'
    }
})
